import dayjs from 'dayjs';
import { getLunar } from 'lunar-info';
export const makeWeekList = (date) => {
    const d = dayjs(date);
    const days = d.daysInMonth();
    const start = d.startOf('month');
    const startWeek = start.day();
    const end = d.endOf('month');
    const endWeek = end.day();
    const startEmptyList = new Array(startWeek).fill('');
    const endEmptyList = new Array(6 - endWeek).fill('');
    const dayList = new Array(days).fill(0).map((_, index) => start.add(index, 'd'));
    const allList = [...startEmptyList, ...dayList, ...endEmptyList];
    const weekNum = Math.ceil(allList.length / 7);
    return new Array(weekNum).fill([]).map((_, index) => allList.slice(index * 7, (index + 1) * 7));
};
export const makeYearWeekList = (date, min, max) => {
    const d = dayjs(date);
    const diffMonth = dayjs(max).diff(dayjs(min), 'month');
    const diffM = min && max && diffMonth < 12 ? diffMonth + 1 : 12;
    return new Array(diffM + 1).fill([]).map((_, index) => makeWeekList(d.add(index, 'M')));
};
export const festList = ['元旦', '情人节', '妇女节', '劳动节', '青年节', '儿童节', '建党日', '建军节', '教师节', '国庆节', '圣诞节', '春节', '元宵节', '清明', '端午节', '七夕', '中秋节', '重阳节', '腊八节'];
export const getLunarText = (d) => {
    const lunar = getLunar(d.year(), d.month() + 1, d.date());
    const { yin_d_name, yin_m_name, yang_jie_ri, yin_jie_ri } = lunar;
    const yinFest = yin_jie_ri.split(' ').find(_ => festList.includes(_));
    const yangFest = yang_jie_ri.split(' ').find(_ => festList.includes(_));
    const lunarText = yin_d_name === '初一' ? yin_m_name : yin_d_name;
    const fest = yangFest || yinFest;
    return { fest, lunar: lunarText };
};
